import React,{useState, useEffect} from 'react';
import api from '@/auth/api';
import { alertSuccess, alertError } from '@/components/Alert';
import { fetchVariableList } from '@/slices/panelSlice/variableListSlice';
import { useDispatch } from 'react-redux';

// Recursive component to render dynamic JSON
const RenderValue = ({ value }) => {
  if (Array.isArray(value)) {
    return (
      <ul className="list-disc ml-4">
        {value.map((item, index) => (
          <li key={index}>
            <RenderValue value={item} />
          </li>
        ))}
      </ul>
    );
  } else if (typeof value === 'object' && value !== null) {
    return (
      <div className="ml-4">
        {Object.entries(value).map(([key, val], index) => (
          <div key={index} className="mb-1">
            <strong>{key}:</strong> <RenderValue value={val} />
          </div>
        ))}
      </div>
    );
  } else {
    return <span>{String(value)}</span>;
  }
};

function TempRecord({ rowData }) {
  const [tempData, setTempData] = useState([]);
  const dispatch = useDispatch()

  useEffect(() => {
    if (rowData?.tempData) {
      setTempData(rowData.tempData);
    }
  }, [rowData]);

  const tempId = rowData?.id || '';

  const handleApplyChanges = async (index, item) => {
    try {
      const resp = await api.post('/panel/PanelVariableUpdate', {
        id: item.id,
      });
      alertSuccess(resp?.data?.success);
      dispatch(fetchVariableList())

      // Update the Used flag in state
      setTempData((prev) =>
        prev.map((entry, i) =>
          i === index ? { ...entry, Used: true } : entry
        )
      );
    } catch (err) {
      alertError(err?.response?.data?.errors);
    }
  };

  return (
    <div className="p-4">
      {/* <h2 className="font-bold text-lg mb-4">Temp Records </h2> */}
      <div className='max-h-[340px] overflow-auto p-4'>
      {tempData.map((item, index) => (
        <div
          key={index}
          className={`relative border ${
            item.Used ? 'border-green-500' : 'border-gray-300'
          } p-4 mb-4 rounded shadow-sm overflow-auto max-h-44`}
        >
          {item.Used ? (
            <span className="absolute top-2 right-2 bg-green-500 text-white text-xs px-2 py-1 rounded">
              USED
            </span>
          ) : (
            <button
              onClick={() => handleApplyChanges(index, item)}
              className="absolute top-2 right-2 bg-blue-500 hover:bg-blue-600 text-white text-xs px-2 py-1 rounded"
            >
              Apply Changes
            </button>
          )}
          <RenderValue value={item} />
        </div>
      ))}
      </div>
      
    </div>
  );
}

export default TempRecord;

